import React from 'react';
import PropTypes from 'prop-types';
import { Spin } from 'antd';
import ModalWrapper from './ModalWrapper';

const TITLES = {
  AUTO_UPLOAD: 'Send to chart',
  CREATE_NEW_CHART: 'Create New Chart',
};

// Stands in for a chart modal while the slide-out loads the record it moved to
// (see reloadChartModalForRecord in reducers/modal). It deliberately shows no
// patient data: the previous record's fields must never sit over the new
// document, even for the moment before the new record's details arrive.
const ChartModalReloading = ({ modalType, hideModal }) => {
  const { reloadType } = modalType.data || {};
  const taskTitle = localStorage.getItem('m8_auto_upload_emr') === 'Kareo'
    ? 'Create Note in Your EMR'
    : 'Create Task in Your EMR';

  return (
    <ModalWrapper
      customContentStyle={{}}
      width={reloadType === 'CREATE_TASK' ? '700px' : '860px'}
      hideModal={hideModal}
      dismiss="Cancel"
      modalTitle={TITLES[reloadType] || taskTitle}
      wrapClassName="chart-modal-wrap"
      transitionName=""
      isDraggable
    >
      <div style={{
        minHeight: 'min(560px, 60vh)', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      }}
      >
        <Spin />
        <div style={{ marginTop: 12, color: '#6b6577' }}>Loading record…</div>
      </div>
    </ModalWrapper>
  );
};

ChartModalReloading.propTypes = {
  modalType: PropTypes.shape({
    data: PropTypes.shape({
      reloadType: PropTypes.string,
    }),
  }).isRequired,
  hideModal: PropTypes.func.isRequired,
};

export default ChartModalReloading;
